<template>
  <div class="tab-content">
    <section class="settings-card">
      <div class="card-header">
        <div class="card-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
        </div>
        <div>
          <h3 class="card-title">Recursos</h3>
          <p class="card-desc">Ative ou desative módulos opcionais do sistema.</p>
        </div>
      </div>

      <div class="feature-flags">
        <div class="feature-flag-row">
          <div class="feature-flag-info">
            <span class="feature-flag-label">Modo Manutenção</span>
            <span class="feature-flag-desc">Habilita o módulo de rotinas e tarefas de manutenção preventiva para esta obra.</span>
          </div>
          <button type="button" class="toggle-btn" :class="{ active: form.maintenanceEnabled }" role="switch"
            :aria-checked="form.maintenanceEnabled"
            @click="$emit('update-form', { field: 'maintenanceEnabled', value: !form.maintenanceEnabled })">
            <span class="toggle-thumb" />
          </button>
        </div>
        <div v-if="form.maintenanceEnabled" class="feature-flag-row">
          <div class="feature-flag-info">
            <span class="feature-flag-label">IA de Manuais (Estagiário) <span class="beta-pill">Beta</span></span>
            <span class="feature-flag-desc">Permite enviar manuais para o EstagIArio Joe interpretar rotinas e responder dúvidas na aba Manuais do Modo Manutenção.</span>
          </div>
          <button type="button" class="toggle-btn" :class="{ active: form.manualsAiEnabled ?? true }" role="switch"
            :aria-checked="form.manualsAiEnabled ?? true"
            @click="$emit('update-form', { field: 'manualsAiEnabled', value: !(form.manualsAiEnabled ?? true) })">
            <span class="toggle-thumb" />
          </button>
        </div>
      </div>

      <div v-if="form.maintenanceEnabled" class="maint-status-config">
        <h4 class="maint-status-title">Textos e cores do status de manutenção</h4>
        <div class="maint-status-row">
          <div class="maint-status-field">
            <label class="maint-status-label">Texto "Pronto"</label>
            <input type="text" class="maint-status-input" :value="form.maintenanceProntoText || 'Pronto'" placeholder="Pronto"
              @input="$emit('update-form', { field: 'maintenanceProntoText', value: ($event.target as HTMLInputElement).value })" />
          </div>
          <div class="maint-status-field maint-status-field--color">
            <label class="maint-status-label">Cor</label>
            <input type="color" class="maint-color-input" :value="form.maintenanceProntoColor || '#16a34a'"
              @input="$emit('update-form', { field: 'maintenanceProntoColor', value: ($event.target as HTMLInputElement).value })" />
          </div>
        </div>
        <div class="maint-status-row">
          <div class="maint-status-field">
            <label class="maint-status-label">Texto "Pendente"</label>
            <input type="text" class="maint-status-input" :value="form.maintenancePendenteText || 'Pendente procedimento'" placeholder="Pendente procedimento"
              @input="$emit('update-form', { field: 'maintenancePendenteText', value: ($event.target as HTMLInputElement).value })" />
          </div>
          <div class="maint-status-field maint-status-field--color">
            <label class="maint-status-label">Cor</label>
            <input type="color" class="maint-color-input" :value="form.maintenancePendenteColor || '#dc2626'"
              @input="$emit('update-form', { field: 'maintenancePendenteColor', value: ($event.target as HTMLInputElement).value })" />
          </div>
        </div>
      </div>

      <div class="save-row">
        <button class="btn-save" type="button" @click="$emit('save')">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
          Salvar
        </button>
        <Transition name="fade"><span v-if="successText" class="save-success">{{ successText }}</span></Transition>
        <p v-if="errorText" class="save-error">{{ errorText }}</p>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import type { SystemConfig } from '@/store/system'
export default defineComponent({
  name: 'SystemTabRecursos',
  props: { form: { type: Object as PropType<SystemConfig>, required: true }, errorText: { type: String, default: '' }, successText: { type: String, default: '' } },
  emits: ['update-form', 'save'],
})
</script>

<style scoped lang="scss">
.tab-content { display: flex; flex-direction: column; gap: 16px; }
.settings-card { border: 1px solid rgba(31,30,26,.1); border-radius: 14px; background: var(--card,#fff); padding: 22px 24px; display: flex; flex-direction: column; gap: 20px; }
.card-header { display: flex; align-items: flex-start; gap: 14px; padding-bottom: 16px; border-bottom: 1px solid rgba(31,30,26,.07); }
.card-icon { width: 36px; height: 36px; border-radius: 9px; flex-shrink: 0; background: rgba(31,30,26,.06); display: flex; align-items: center; justify-content: center; }
.card-title { margin: 0 0 2px; font-size: 15px; font-weight: 700; color: var(--ink,#2c2b27); }
.card-desc { margin: 0; font-size: 12px; color: var(--ink-muted,#888); }
.feature-flags { display: flex; flex-direction: column; gap: 12px; }
.feature-flag-row { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 14px 16px; border: 1px solid rgba(31,30,26,.1); border-radius: 10px; background: rgba(255,255,255,.6); }
.feature-flag-info { display: flex; flex-direction: column; gap: 3px; }
.feature-flag-label { font-size: 13px; font-weight: 700; color: var(--ink); }
.beta-pill { font-size: 9px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; background: rgba(124,58,237,.12); color: #7c3aed; border: 1px solid rgba(124,58,237,.35); border-radius: 999px; padding: 1px 7px; margin-left: 4px; vertical-align: middle; }
.feature-flag-desc { font-size: 12px; color: var(--ink-muted); }
.toggle-btn { position: relative; width: 40px; height: 22px; border-radius: 999px; border: none; background: rgba(31,30,26,.18); cursor: pointer; flex-shrink: 0; transition: background .2s; &.active { background: var(--accent); } }
.toggle-thumb { position: absolute; top: 3px; left: 3px; width: 16px; height: 16px; border-radius: 50%; background: #fff; transition: transform .2s; pointer-events: none; .toggle-btn.active & { transform: translateX(18px); } }
.maint-status-config { border-top: 1px solid rgba(31,30,26,.08); padding-top: 14px; display: flex; flex-direction: column; gap: 10px; }
.maint-status-title { font-size: 13px; font-weight: 700; color: var(--ink); margin: 0 0 4px; }
.maint-status-row { display: flex; align-items: flex-end; gap: 10px; }
.maint-status-field { display: flex; flex-direction: column; gap: 4px; flex: 1; &--color { flex: 0 0 auto; } }
.maint-status-label { font-size: 12px; color: var(--ink-muted); }
.maint-status-input { border: 1px solid rgba(31,30,26,.15); border-radius: 8px; padding: 7px 10px; font-size: 13px; color: var(--ink); background: var(--bg,#fff); outline: none; &:focus { border-color: var(--accent); } }
.maint-color-input { width: 44px; height: 34px; border: 1px solid rgba(31,30,26,.15); border-radius: 8px; padding: 2px; cursor: pointer; background: none; }
.save-row { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
.btn-save { display: inline-flex; align-items: center; gap: 8px; padding: 11px 24px; border-radius: 10px; border: none; cursor: pointer; background: var(--system-navbar,#0f4c81); color: #fff; font-size: 14px; font-weight: 700; &:hover { opacity: .88; } }
.save-success { font-size: 13px; font-weight: 600; color: #15803d; }
.save-error { margin: 0; font-size: 13px; color: #dc2626; }
.fade-enter-active, .fade-leave-active { transition: opacity .3s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
